import ActiveTableComponent from './ActiveTable'
export default (Vue) => {
  Vue.component(ActiveTableComponent.name, ActiveTableComponent)
}



// WEBPACK FOOTER //
// ./src/components/ActiveTable/index.js